export const toPath =
    (name) =>
        name.replace(/-/g, '')
            .replace(/\s/g, '-')
            .replace(/[.,]/g, '')
            .toLowerCase();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/helpers/toPath.ts